<template>
  <div class="MyVideo">
    <video :src="v.src?v.src: tmpVedio" class="v" :controls="playing"
           @canplay="updatePaused" @playing="updatePaused" @pause="updatePaused"
           :poster="v.poster?v.poster:''" controlsList="nodownload" :style="inputStyle"
    >
    </video>
    <div v-if="$store.state.mediaPhone">
      <svg v-if="!playing" class="video-overlay-play-button" alt="Play video" @click="play">
        <circle cx="15" cy="15" r="15" fill="rgba(0,0,0,0.5)"/>
        <polygon points="10,9 10,22 22,16" fill="#fff"/>
      </svg>
    </div>
    <div v-else>
      <svg v-if="!playing" class="video-overlay-play-button" alt="Play video" @click="play">
        <circle cx="30" cy="30" r="30" fill="rgba(0,0,0,0.5)"/>
        <polygon points="20,19 20,45 44,32" fill="#fff"/>
      </svg>
    </div>
  </div>
</template>

<script>
 export default {
   name: 'MyVideo',
   props: ['v', 'inputStyle'],
   data () {
     return {
       paused: true,
       video: null
     }
   },

   methods: {
     updatePaused(event) {
       this.video = event.target;
       this.paused = event.target.paused;
     },
     play() {
       this.video.play();
     },
   },
   computed: {
     playing() {
       return !this.paused;
     },
     tmpVedio() {
       return '';
     },
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .MyVideo{
   position: relative;
 }
 .video-overlay-play-button{
   width: 60px;
   height: 60px;
   box-sizing: border-box;
   position: absolute;
   left: calc(50% - 30px);
   top: calc(50% - 30px);
   cursor:pointer;
 }
 .v{
   margin-top: 1.46vw;
   width: 17vw;
   height: 10.4vw;
 }
 
 @media (min-width: 320px) and (max-width: 480px) {
   .video-overlay-play-button{
     width: 30px;
     height: 30px;
     
     left: calc(50% - 15px);
     top: calc(50% - 15px);
   }
 }
</style>
